import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { CostHintResponse } from "@/models/api/administration/servicesAndAttributes/CostHint";
import { CostHintEdit } from "@/models/api/administration/servicesAndAttributes/CostHintEdit";
import { CostHintSelect } from "@/models/api/administration/servicesAndAttributes/CostHintSelect";
import { COST_HINT_TYPE } from "@/static/costHintTypeEnum";

//#region Routes
export const URL_GET_COST_HINTS = "/CostHint/Paged";
export const URL_GET_COST_HINT = "/CostHint/${CostHintId}";
export const URL_POST_ADD_COST_HINT = "/CostHint/Add";
export const URL_POST_EDIT_COST_HINT = "/CostHint/Edit";
export const URL_POST_REMOVE_COST_HINT = "/CostHint/Remove/${CostHintId}";
export const URL_GET_COST_HINT_FOR_EDITOR = "/CostHint/ForEditor/${CostHintTypeEnum}";
export const URL_POST_UPDATE_COST_HINT_COUNTER = "/CostHint/Counter/${CostHintId}";

//#endregion

const _getCostHints = new CancellableHelper<CostHintResponse>(URL_GET_COST_HINTS, CostHintResponse);
_getCostHints.jsonSerializer = true;
export const getCostHints = async (genericTableRequest: GenericTableRequest): Promise<CostHintResponse> => {
  return await _getCostHints.get(genericTableRequest);
};

const _getCostHint = new CancellableHelper<CostHintEdit>(URL_GET_COST_HINT, CostHintEdit);
export const getCostHint = async (costHintId: number): Promise<CostHintEdit> => {
  return await _getCostHint.get({ CostHintId: costHintId });
};

const _addCostHint = new CancellableHelper<null>(URL_POST_ADD_COST_HINT, null, true);
export const addCostHint = async (model: CostHintEdit): Promise<null> => {
  return await _addCostHint.post(null, model);
};

const _editCostHint = new CancellableHelper<null>(URL_POST_EDIT_COST_HINT, null, true);
export const editCostHint = async (model: CostHintEdit): Promise<null> => {
  return await _editCostHint.post(null, model);
};

const _removeCostHint = new CancellableHelper<null>(URL_POST_REMOVE_COST_HINT, null, true);
export const removeCostHint = async (costHintId: number): Promise<null> => {
  return await _removeCostHint.post({ CostHintId: costHintId }, null);
};

const _getCostHintsForEditor = new CancellableHelper<Array<CostHintSelect>>(
  URL_GET_COST_HINT_FOR_EDITOR,
  CostHintSelect
);
export const getCostHintsForEditor = async (costHintTypeEnum: COST_HINT_TYPE): Promise<Array<CostHintSelect>> => {
  return await _getCostHintsForEditor.get({ CostHintTypeEnum: costHintTypeEnum });
};

const _updateCostHintCounter = new CancellableHelper<null>(URL_POST_UPDATE_COST_HINT_COUNTER, null, true);
export const updateCostHintCounter = async (costHintId: number): Promise<null> => {
  return await _updateCostHintCounter.post({ CostHintId: costHintId }, null);
};
